import { render } from "./NavigatorCallout.vue?vue&type=template&id=0ae81bc4&scoped=true"
import script from "./NavigatorCallout.vue?vue&type=script&lang=js"
export * from "./NavigatorCallout.vue?vue&type=script&lang=js"

import "./NavigatorCallout.vue?vue&type=style&index=0&id=0ae81bc4&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae81bc4"],['__file',"resources/js/components/NavigatorCallout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ae81bc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ae81bc4', __exports__)) {
    api.reload('0ae81bc4', __exports__)
  }
  
  module.hot.accept("./NavigatorCallout.vue?vue&type=template&id=0ae81bc4&scoped=true", () => {
    api.rerender('0ae81bc4', render)
  })

}


export default __exports__